import { throwError as observableThrowError, Observable } from 'rxjs';

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ServiceBase } from "./base.service";
import { catchError } from "rxjs/operators";

@Injectable()
export class PlanoControleService extends ServiceBase{
    constructor(private http: HttpClient) {
        super();
    }

    obterControle(){
        return this.http.get<any>(this.URL_API + 'PlanoControle').pipe(
            catchError((error: any) => observableThrowError(error)));
    }
}